import script from "./ChatRegionsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatRegionsCard.vue?vue&type=script&setup=true&lang=js"

import "./ChatRegionsCard.vue?vue&type=style&index=0&id=5d30cc4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d30cc4e"]])

export default __exports__